<template>
  <div class="keyboard-area">
    <div class="keyboard-wrapper" ref="keyboardWrapper">
      <div class="keymap-info" ref="mover">
        <h3 v-if="mapName" class="current-keymap">
          {{
            mapName.toUpperCase().includes("LATYN")
              ? ls_KazakhLatyn
              : mapName.toUpperCase().includes("CYRL")
              ? ls_KazakhCyrl
              : ls_KazakhTote
          }}
        </h3>
        <span class="close-btn" @click="$emit('closeKeyboard')">
          <i class="fal fa-times"></i>
        </span>
      </div>
      <ul class="keyboard">
        <li
          v-for="(key, index) in keyMap"
          :class="{
            'delete-key': key === 'Delete',
            'tab-key': key === 'Tab',
            'caps-lock-key': key === 'Caps',
            'enter-key': key === 'Enter',
            'shift-key': key === 'Shift',
            'ctrl-key': key === 'Ctrl',
            'alt-key': key === 'Alt',
            'space-key': key === 'Space',
            'shift-ing': key === 'Shift' && shifted,
            'caps-lock-ing': key === 'Caps' && capsed,
            'ctrl-ing': key === 'Ctrl' && ctrled,
            'alt-ing': key === 'Alt' && alted,
            'font-kaznet': mapName === 'kazakhTote',
            'hovered-key':
              key === hoverKey ||
              (key === 'Space' && hoverKey === ' ') ||
              (key === 'Delete' && hoverKey === 8) ||
              (key === 'Caps' && hoverKey === 20) ||
              (key === 'Enter' && hoverKey === 13) ||
              (key === 'Shift' && hoverKey === 16) ||
              (key === 'Ctrl' && hoverKey === 17) ||
              (key === 'Alt' && hoverKey === 18)
          }"
          @click="press(key)"
          :key="index"
          class="key"
        >
          {{ key === "Space" ? "" : key }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import keymap from "@/assets/js/keymap.js";

export default {
  props: ["baseText", "mapName", "bindElement", "hoverKey"],

  data() {
    return {
      keyMap: [],
      shifted: false,
      capsed: false,
      ctrled: false,
      alted: false
    };
  },

  computed: {
    ls_KazakhLatyn() {
      return this.$store.state.languagePack.ls_KazakhLatyn;
    },
    ls_KazakhCyrl() {
      return this.$store.state.languagePack.ls_KazakhCyrl;
    },
    ls_KazakhTote() {
      return this.$store.state.languagePack.ls_KazakhTote;
    }
  },

  methods: {
    press(key) {
      let text = this.baseText;
      let position = [
        this.bindElement.selectionStart,
        this.bindElement.selectionEnd
      ];

      if (position[1] - position[0] < 2) {
        position = [position[0], position[0]];
      }

      switch (key) {
        case "Delete":
          if (position) {
            text = text.length
              ? text.substring(0, position[0] - 1) +
                text.substring(position[1], text.length)
              : text;
            position = [position[0] - 1, position[0] - 1];
          } else {
            text = text.length ? text.substring(0, text.length - 1) : text;
            position = [position[0] - 1, position[0] - 1];
          }
          break;

        case "Tab":
          if (position) {
            text =
              text.substring(0, position[0]) +
              "\t" +
              text.substring(position[1], text.length);
          } else {
            text += "\t";
          }
          position = [position[0] + 1, position[0] + 1];
          break;

        case "Enter":
          if (position) {
            text =
              text.substring(0, position[0]) +
              "\n" +
              text.substring(position[1], text.length);
          } else {
            text += "\n";
          }
          position = [position[0] + 1, position[0] + 1];
          break;

        case "Space":
          if (position) {
            text =
              text.substring(0, position[0]) +
              " " +
              text.substring(position[1], text.length);
          } else {
            text += " ";
          }
          position = [position[0] + 1, position[0] + 1];
          break;

        case "Caps":
          if (this.shifted) {
            this.shifted = !this.shifted;
          } else {
            this.capsed = !this.capsed;
          }
          break;

        case "Shift":
          if (this.capsed) {
            this.capsed = !this.capsed;
          } else {
            this.shifted = !this.shifted;
          }
          break;

        case "Ctrl":
          this.ctrled = !this.ctrled;
          break;

        case "Alt":
          this.alted = !this.alted;
          break;

        default:
          if (position !== []) {
            if (key === "i̇") key = String.fromCharCode("0x69");
            text =
              text.substring(0, position[0]) +
              key.toString() +
              text.substring(position[1], text.length);
          } else {
            text += key.toString();
          }
          if (this.shifted) this.shifted = false;
          if (this.alted) this.alted = false;
          if (this.ctrled) this.ctrled = false;

          position = [position[0] + 1, position[0] + 1];
          break;
      }

      this.$emit("keypressing", {
        text: text,
        position: position
      });
    }
  },

  watch: {
    mapName(newVal, oldVal) {
      if (newVal === oldVal) return;

      if (keymap[newVal] !== undefined) {
        this.keyMap = keymap[newVal]["default"];
      }
    },

    shifted(newVal, oldVal) {
      if (newVal === oldVal) return;

      if (this.shifted) {
        this.keyMap = keymap[this.mapName]["shifted"];
      } else {
        this.keyMap = keymap[this.mapName]["default"];
      }
    },

    capsed(newVal, oldVal) {
      if (newVal === oldVal) return;

      if (this.capsed) {
        this.keyMap = keymap[this.mapName]["capsed"];
      } else {
        this.keyMap = keymap[this.mapName]["default"];
      }
    },

    hoverKey(newVal, oldVal) {
      if (newVal === 16) {
        this.shifted = !this.shifted;
        let timer = setTimeout(() => {
          this.shifted = !this.shifted;
          clearTimeout(timer);
        }, 300);
      } else if (newVal === 20) {
        this.capsed = !this.capsed;
      }
    }
  },

  mounted() {
    let keyboardWrapper = this.$refs.keyboardWrapper;
    let keyboardMover = this.$refs.mover;
    let disX = 0; // mouse position left - keyboard left
    let disY = 0; // mouse position top - keyboard top

    keyboardMover.addEventListener("mousedown", ev => {
      ev = ev || window.event;
      disX = ev.clientX - keyboardWrapper.offsetLeft;
      disY = ev.clientY - keyboardWrapper.offsetTop;

      // Not keyboardWrapper, because mouse out of the area when speed is quickly;
      document.onmousemove = ev => {
        ev = ev || window.event;

        let kbLeft = ev.clientX - disX;
        let kbTop = ev.clientY - disY;
        let maxLeft =
          document.documentElement.offsetWidth - keyboardWrapper.offsetWidth;
        let maxTop =
          document.documentElement.offsetHeight - keyboardWrapper.offsetHeight;

        keyboardWrapper.style.left =
          kbLeft < 0 ? 0 : kbLeft > maxLeft ? maxLeft + "px" : kbLeft + "px";
        keyboardWrapper.style.top =
          kbTop < 0 ? 0 : kbTop > maxTop ? maxTop + "px" : kbTop + "px";
      };

      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };

      return false;
    });

    this.keyMap = keymap["kazakhLatyn"]["default"];
  }
};
</script>

<style lang="scss" scoped>
.keyboard-area {
  position: relative;
  height: 0;
  z-index: 1;

  .keyboard-wrapper {
    position: fixed;
    top: 330px;
    left: auto;
    width: 520px;
    background-color: #ffffff;
    border: 1px solid #0000004d;
    border-radius: 3px;
    box-shadow: 0 4px 16px #00000033;
    padding: 10px;
    z-index: 999999;

    .keymap-info {
      position: relative;
      padding: 3px;
      user-select: none;
      width: 470px;
      cursor: move;

      .current-keymap {
        font-size: 14px;
        user-select: none;
        color: #888888;
      }

      .close-btn {
        position: absolute;
        right: -20px;
        top: 0;
        color: #888888;
        cursor: default;

        &:hover {
          color: #212525;
        }
      }
    }

    .keyboard {
      width: 500px;
      margin: 0;
      padding: 0;
      list-style: none;
      user-select: none;

      .key {
        float: left;
        margin: 2px;
        width: 29px;
        height: 29px;
        line-height: 25px;
        text-align: center;
        background-color: #f5f5f5;
        border: 1px solid #0000001a;
        border-radius: 3px;
        color: #555555;
        font-family: Roboto, Arial, Helvetica, sans-serif, KazNet;
        cursor: default;

        &:hover {
          position: relative;
          border-color: #eceeef;
        }

        &:active {
          top: 1px;
          left: 1px;
          background-color: #d5d5d5;
        }
      }

      .hovered-key {
        top: 1px;
        left: 1px;
        background-color: #d5d5d5;
      }

      .tab-key,
      .delete-key,
      .ctrl-key {
        width: 62px;
      }

      .caps-lock-key {
        width: 67px;
      }

      .alt-key,
      .enter-key {
        width: 57px;
      }

      .shift-key {
        width: 78px;
      }

      .space-key {
        width: 236px;
      }

      .shift-ing,
      .caps-lock-ing,
      .ctrl-ing {
        background-color: #e0e0e0;
      }
    }
  }
}
</style>
